var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedgerCosmosApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wallets / Cosmos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-Connection",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_Leger_a",
    transform: "translate(-554.000000, -312.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connection-TradeHub",
    transform: "translate(490.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Choose-the-App",
    transform: "translate(40.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallets-/-Cosmos",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E3EBFB",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2751184,12.1664991 L12.245418,18.1964444 C12.1676962,18.0455811 12.0975124,17.8883934 12.0346627,17.7252896 C11.8241111,17.1774281 11.7187843,16.5961093 11.7187843,15.9822106 C11.7187843,15.3677916 11.8241111,14.7867585 12.0346627,14.2388663 C12.245418,13.6907395 12.5374603,13.2152393 12.9107895,12.8116313 C13.2842206,12.4082681 13.7329288,12.0892415 14.2566084,11.8542965 C14.7806954,11.6195862 15.3556123,11.5021188 15.9817665,11.5021188 C16.6081243,11.5021188 17.186199,11.6225137 17.7157866,11.8635585 C17.9127904,11.9529953 18.0992004,12.0538973 18.2751184,12.1664991 Z M17.743086,20.1459381 C17.2191008,20.3808525 16.644184,20.4981566 16.0180298,20.4981566 C15.3916719,20.4981566 14.8135973,20.3776903 14.283704,20.1369617 C14.0870059,20.0471985 13.9005959,19.9463169 13.7248816,19.8335009 L19.7542764,13.8040554 C19.8321001,13.954674 19.9022839,14.1116372 19.9651336,14.2749246 C20.1756852,14.8228168 20.2810119,15.4040947 20.2810119,16.0182689 C20.2810119,16.6324226 20.1756852,17.2134353 19.9651336,17.7616029 C19.7542764,18.3094645 19.462336,18.7850055 19.0889049,19.1883279 C18.7155756,19.5917523 18.2670712,19.9110237 17.743086,20.1459381 Z M18.6553744,22.0155628 C19.462336,21.6663024 20.1608132,21.1937195 20.7509077,20.5973042 C21.3409003,20.0013989 21.7983687,19.3058361 22.1235166,18.5110237 C22.4488682,17.7163133 22.6114422,16.8732532 22.6114422,15.9822106 C22.6114422,15.0909129 22.4488682,14.2478834 22.1235166,13.452867 C21.9307911,12.9815082 21.6933476,12.5462179 21.4115935,12.1467512 L25.3333333,8.22502732 L23.7750275,6.66666667 L19.8413696,10.6003352 C19.4882093,10.3595454 19.1047956,10.1514069 18.691434,9.97568525 C17.8844724,9.63252459 16.9933716,9.46069945 16.0180298,9.46069945 C15.0423824,9.46069945 14.1513835,9.63544189 13.3444219,9.98470237 C12.5374603,10.3339526 11.8388812,10.8065253 11.2488886,11.4026754 C10.6587941,11.9988153 10.201122,12.6943985 9.87597407,13.4891803 C9.55082618,14.2839519 9.38825224,15.1269916 9.38825224,16.0182791 C9.38825224,16.9093625 9.55082618,17.7521166 9.87597407,18.547133 C10.0690052,19.0186958 10.3063468,19.4540474 10.5881009,19.8536976 L6.66666667,23.7750237 L8.22497253,25.3333333 L12.1584266,21.3998689 C12.511587,21.6406995 12.8950007,21.8488889 13.3083623,22.0245392 C14.1153239,22.3676794 15.0063228,22.5393515 15.9817665,22.5393515 C16.957312,22.5393515 17.8484128,22.3645173 18.6553744,22.0155628 Z",
    id: "Cosmos-Logo",
    fill: "#000000"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerCosmosApp);
export default __webpack_public_path__ + "static/media/LedgerCosmosApp.0bcf3ddd24caa2d3c2fa3092a55df081.svg";
export { ForwardRef as ReactComponent };